import SizeBox from 'components/common/SizeBox';
import {
  ADD_TRANSACTION_PAYMENT_METHOD_ITEM_NAME,
  DESKTOP_MIN_WIDTH,
  METHOD_PAYTO,
} from 'constants';
import usePayment from 'features/to/hooks/payment/usePayment';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import useFxFormAddTransactionStore from 'hooks/fx/useFxFormAddTransactionStore';
import useLang from 'hooks/useLang';
import usePage from 'hooks/usePage';
import useScrollIntoView from 'hooks/useScrollIntoView';
import { isEmpty } from 'lodash';
import React, { useRef } from 'react';
import styled from 'styled-components';
import { paragraph500Mixin } from 'styles';
import AddAnotherAccountAgreement from './components/AddAnotherAccountAgreement';
import PaytoAccountAgreementItem from './components/PaytoAccountAgreementItem';

const PaytoAccountsAgreement = ({ validation }) => {
  const { t } = useLang();
  const { paymentMethodName } = usePayment();
  const { paytoAccountsAgreement } = usePaytoStore();
  const { paymentMethodName: fxPaymentMethodName } =
    useFxFormAddTransactionStore();
  const { isAddTransactionPage, isFxAddTransactionPage } = usePage();

  const isRequired = validation?.[ADD_TRANSACTION_PAYMENT_METHOD_ITEM_NAME];

  const validRef = useRef(null);
  useScrollIntoView(validRef, isRequired, [validation]);

  if (isAddTransactionPage && paymentMethodName !== METHOD_PAYTO) return null;
  if (isFxAddTransactionPage && fxPaymentMethodName !== METHOD_PAYTO)
    return null;
  if (isEmpty(paytoAccountsAgreement)) return null;
  return (
    <>
      <SizeBox height={16} />
      <SelectLabel ref={validRef} $isRequired={isRequired}>
        {t('label_please_select_an_agreement')}
      </SelectLabel>
      <SizeBox height={16} />
      <PaytoAccountsAgreementStyled $isRequired={isRequired}>
        {paytoAccountsAgreement?.map((account, i) => (
          <PaytoAccountAgreementItem
            key={i}
            data={account}
            index={i}
            isShowIframeModal={true}
          />
        ))}
        <AddAnotherAccountAgreement />
      </PaytoAccountsAgreementStyled>
    </>
  );
};

const PaytoAccountsAgreementStyled = styled.div`
  background: var(--ds-bg-1);
  border-radius: 8px;
  padding: 8px;
  width: 100%;
  ${(props) =>
    props.$isRequired &&
    `
    border: 1px solid #000;
  `}

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    width: 436px;
  }
`;

const SelectLabel = styled.p`
  ${paragraph500Mixin};
  ${(props) =>
    props.$isRequired &&
    `
    color: var(--ds-c-red);
  `}
`;

export default PaytoAccountsAgreement;
